
export default function (Component) {
  Component.options.__source = "src/layout/no-header/layout.vue"
}
